'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _shipping_template = require('../actions/shipping_template');

var _shipping_template_form = require('../components/shipping_template_form');

var _shipping_template_form2 = _interopRequireDefault(_shipping_template_form);

var _shipping_template_list = require('../components/shipping_template_list');

var _shipping_template_list2 = _interopRequireDefault(_shipping_template_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingTemplate = _react2.default.createClass({
    displayName: 'ShippingTemplate',

    propTypes: {
        shippingTemplates: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _shipping_template.fetchShippingTemplatesIfNeeded)(filter));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'shiping-templates', className: 'clearfix' },
            _react2.default.createElement(
                _button2.default,
                { type: 'primary', style: { marginBottom: 20 } },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/express/create' },
                    '\u521B\u5EFA\u8FD0\u8D39\u6A21\u7248'
                )
            ),
            _react2.default.createElement(_shipping_template_list2.default, { shippingTemplates: this.props.shippingTemplates })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var shippingTemplates = store.shippingTemplate.shippingTemplates;

    return {
        shippingTemplates: shippingTemplates
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ShippingTemplate);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/shipping_templates.js
// module id = 1527
// module chunks = 0